/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {inject} from "@angular/core";
import {LoginService} from "@irian-ro/auth-shared-module";
import {ResolveFn} from "@angular/router";

export const logoutResolver: ResolveFn<void> = () => {
  inject(LoginService).logout(false).subscribe();
}
